import Menu from "./Menu";
import Logo from '../../assets/img/logosvgblackred.svg';
import Logoin from '../../assets/img/logosvgwhitered.svg';
import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";

const Header = () => {
    const [scroll, setScroll] = useState(false)
    const [active, setActive] = useState(false)
    const location = useLocation();
    const locPath = location.pathname.split('/');
    const pageId = locPath[locPath.length - 1]

    window.addEventListener(
        "scroll",
        () => {
            setScroll(window.pageYOffset)
        },
        false
    );
    // console.log(scroll);


    return (
        <header className="header z-3">
            <nav className={`navbar navbar-expand-lg fixed-top  custom_navbar px-0 px-md-4  ${pageId ? 'active shadow-sm' : scroll > 10 ? 'active shadow-sm' : active ? 'active shadow-sm' : ''}`}>
                <div className="container-fluid z-1">
                    <NavLink to={"/"} className="navbar-brand " href="#">
                        <img src={Logo} alt="First Resource Logo" className="header_logo" />
                    </NavLink>
                    <button className="navbar-toggler custom_nav_toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setActive(v => v = !v)}>
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <Menu />
                </div>
            </nav>
        </header>
    )
}
export default Header;